module.exports = __webpack_public_path__ + "static/media/ayna1.c67fa07e.png";